<template>
  <div class="shopping-cart mt-5"
       v-if="getCartCount===0"
  >
    <span class="col-12">
      <div class="empty-cart emptyCart d-none d-lg-flex"
           @click.prevent="$router.push('/')"
											data-test="mobileCartHomeRedirect"
											id="mobileCartHomeRedirect"
      >
        <!--<h4 id="empty-cart-heading">No items in your cart</h4>-->
        <img src="@/assets/img/empty-cart.jpg"
             alt=""
             srcset=""
             style=" cursor: pointer"
             id="empty-cart-img"
             @click.prevent="$router.push('/')"
													data-test="mobileCartEmptyCartImg"
        >
      </div>
      <div class="emptyCartMobile d-lg-none">
        <img src="@/assets/img/empty-cart.png"
             alt="EmptyCart"
													data-test="mobileCartEmptyCartImg2"
													id="mobileCartEmptyCartImg2"
        >
        <h3 class="pt-2" data-test="mobileCartEmptyCartHead"
												id="mobileCartEmptyCartHead">
          Your Cart Is Empty
        </h3>
        <button class="btn btn-primary btn-type-primary cart-fixed-button"
                @click.prevent="$router.push('/')"
																data-test="mobileCartContinueShopping"
																id="mobileCartContinueShopping"
        >
          Continue Shopping
        </button>
      </div>
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	computed: {
		...mapGetters('cart', ['getCartCount'])
	}
}
</script>
<style lang="scss">
  @media only screen and (max-width: 991.98px) {
    .emptyCart {
      display: none;
    }
  }

  .emptyCartMobile {
    text-align: center;
    padding: 2.5em;
  }
</style>
